/**
 * LERA Device Engine — Alias Resolver
 * Maps brands to catalog patterns and normalizes model strings.
 */
(function (global) {
  'use strict';

  var LERA = (global.LERA = global.LERA || {});
  LERA._modules = LERA._modules || {};

  var DEFAULT_ALIASES = {
    apple: ['iphone', 'ipad', 'ipod'],
    samsung: ['galaxy', 'samsung', 's24', 's25', 's23', 's22'],
    google: ['pixel', 'google'],
    'google pixel': ['pixel', 'google'],
    motorola: ['motorola', 'moto', 'edge', 'razr'],
    huawei: ['huawei', 'mate', 'p'],
    honor: ['honor'],
    xiaomi: ['xiaomi', 'redmi', 'poco', 'mi'],
    otros: [],
  };

  function normalizeKey(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeModel(value) {
    var normalized = String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .replace(/[_]+/g, ' ')
      .replace(/[-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!normalized) return '';

    return normalized
      .split(' ')
      .map(function (part) {
        if (!part) return '';
        if (/^s\d+/i.test(part)) return part.toUpperCase();
        if (/^mi$/i.test(part)) return 'Mi';
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      })
      .join(' ')
      .replace(/\bIphone\b/g, 'iPhone')
      .replace(/\bIpad\b/g, 'iPad')
      .replace(/\bIpod\b/g, 'iPod');
  }

  function parseCustomAliases(text) {
    var aliases = {};
    if (!text) return aliases;

    String(text)
      .split('\n')
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean)
      .forEach(function (line) {
        var parts = line.split('|');
        var brand = normalizeKey(parts[0]);
        if (!brand) return;

        var patterns = (parts[1] || '')
          .split(',')
          .map(function (pattern) {
            return pattern.trim().toLowerCase();
          })
          .filter(Boolean);

        aliases[brand] = patterns;
      });

    return aliases;
  }

  function AliasResolver(config) {
    this.customAliases = parseCustomAliases(config && config.customAliases);
    this.diagnostics = {
      aliasesLoaded: Object.keys(DEFAULT_ALIASES).length + Object.keys(this.customAliases).length,
    };
  }

  AliasResolver.prototype.getBrandPatterns = function (brandName) {
    var key = normalizeKey(brandName);
    var patterns = [];

    if (this.customAliases[key]) {
      patterns = patterns.concat(this.customAliases[key]);
    }

    if (DEFAULT_ALIASES[key]) {
      patterns = patterns.concat(DEFAULT_ALIASES[key]);
    }

  if (!patterns.length) {
      patterns.push(key);
    }

    var unique = Object.create(null);
    patterns.forEach(function (pattern) {
      if (pattern) unique[pattern.toLowerCase()] = true;
    });

    return Object.keys(unique);
  };

  AliasResolver.prototype.resolveAlias = function (brandName) {
    return {
      brand: brandName,
      patterns: this.getBrandPatterns(brandName),
      normalizedBrand: normalizeKey(brandName),
    };
  };

  AliasResolver.prototype.matchesBrandModel = function (brandName, modelName) {
    var patterns = this.getBrandPatterns(brandName);
    var normalizedModel = normalizeKey(modelName);

    if (!normalizedModel) return false;

    return patterns.some(function (pattern) {
      return normalizedModel.indexOf(pattern) !== -1;
    });
  };

  AliasResolver.prototype.expandSearchTerms = function (brandName, query) {
    var patterns = this.getBrandPatterns(brandName);
    var terms = [String(query || '').trim()];
    patterns.forEach(function (pattern) {
      terms.push(pattern + ' ' + String(query || '').trim());
    });
    return terms
      .map(function (term) {
        return term.trim();
      })
      .filter(Boolean);
  };

  AliasResolver.prototype.normalize = normalizeModel;
  AliasResolver.prototype.normalizeKey = normalizeKey;

  LERA._modules.aliasResolver = AliasResolver;
})(typeof window !== 'undefined' ? window : this);
